import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

/** Start a demo and open its dashboard. The homepage and /demo-ended share it. */
export function useStartDemo() {
  const startDemo = useAuthStore((s) => s.startDemo);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const start = useCallback(async () => {
    setLoading(true);
    const result = await startDemo();
    setLoading(false);
    if (result.success) navigate('/dashboard');
  }, [startDemo, navigate]);

  return { start, loading };
}
